import { render } from "./IncomeForm.vue?vue&type=template&id=c70e1a9a&scoped=true"
import script from "./IncomeForm.vue?vue&type=script&lang=js"
export * from "./IncomeForm.vue?vue&type=script&lang=js"

import "./IncomeForm.vue?vue&type=style&index=0&id=c70e1a9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70e1a9a"]])

export default __exports__